import { AfterViewInit, Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';

export interface EmployeeList {
  material: string;
  defcost: number;
  requiredqty: number;
  expusageqty: number;
  stockqty: number;
  orderedqty: number;
  needtobuyqty: number;
  unit: number;
  
}

const ELEMENT_DATA: EmployeeList[] = [
  {
    material: 'sahil patel', defcost: 26, requiredqty: 78, expusageqty: 151,
    stockqty: 2, orderedqty: 3, needtobuyqty: 5, unit: 544
  },
  {
    material: 'deep patel', defcost: 58, requiredqty: 85, expusageqty: 515,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2,orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2, orderedqty: 3,  needtobuyqty: 5, unit: 544
  },
  {
    material: 'umang patel', defcost: 95, requiredqty: 65, expusageqty: 845,
    stockqty: 2,orderedqty: 3, needtobuyqty: 5, unit: 544
  },
];

@Component({
  selector: 'app-material-availability-check',
  templateUrl: './material-availability-check.component.html',
  styleUrls: ['./material-availability-check.component.scss']
})
export class MaterialAvailabilityCheckComponent implements OnInit {

  displayedColumns: string[] = ['material', 'defcost', 'requiredqty', 'expusageqty', 'stockqty', 'orderedqty', 'needtobuyqty', 'unit'];
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);
  @ViewChild('epltable', { static: false }) epltable!: ElementRef;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =   
    xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
     
    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'Stock.xlsx');
   }

   backBtn() {
    this.router.navigate(['/Stock']);
  }

}
